module.exports = __webpack_public_path__ + "static/media/logo-goodwe.b9e49a68.svg";